import { frontendURL } from 'dashboard/helper/URLHelper';

import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import ConversationResolutionSubjectsHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/conversation-resolution-subjects'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'conversation_resolution_subjects_list',
          meta: {
            permissions: ['administrator'],
          },
          component: ConversationResolutionSubjectsHome,
        },
      ],
    },
  ],
};
